/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-table{display:block}.mat-form-field,.mat-header-row,.mat-row,.mat-select{max-height:10px;padding:0;margin:0}.chip-list{width:100%}"];
export { styles as styles };
